import React, { useState, useEffect } from 'react';
import {
	FingotiHeader,
	FingotiLoading,
	FingotiButton,
	FingotiModal,
} from '@fingoti/components';

import makeStyles from '@material-ui/core/styles/makeStyles';

import { DeviceIcon } from '../../icons/FingotIcons';

import { DevicesView } from './DevicesView';
import { DeviceList } from './DeviceList';
import { DeviceDetails } from './DeviceDetails';
import { ClaimGateway } from './gateway/ClaimGateway';

import { useDeviceState } from '../../context/DeviceContext';
import { sortDevices } from './_deviceFunctions';
import { useFingotiScopes } from '@fingoti/auth-js/react';

const useStyles = makeStyles((theme) => ({
	noneSelected: {
		paddingLeft: theme.spacing(4),
		height: '100%',
		display: 'flex',
	},
	noneSelectedContent: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	noneSelectedIcon: {
		fontSize: '3rem',
		color: theme.palette.greyOne.main,
	},
	invalidNodeWrapper: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
	},
	invalidNode: {
		borderRadius: theme.spacing(1) / 2,
		padding: theme.spacing(4),
		margin: theme.spacing(2),
		color: theme.palette.error.main,
		textAlign: 'center',
	},
	invalidNodeIcon: {
		fontSize: '8rem',
		paddingBottom: theme.spacing(2),
		paddingTop: theme.spacing(2),
	},
}));

export const AllDevices = () => {
	const classes = useStyles();
	const { hasScope } = useFingotiScopes(); //Called here and passed to avoid breaking hook rules
	const { peblGateways, vyneGateways, vyneNodes, loaded } = useDeviceState();
	const [thisLoading, setThisLoading] = useState(true);
	const [selectedDevice, setSelectedDevice] = useState(undefined);
	const [devices, setDevices] = useState([]);
	const [addOpen, setAddOpen] = useState(false);
	const [sortDetails, setSortDetails] = useState(['online', 'asc']);

	useEffect(() => {
		let persistedSort = localStorage.getItem('device-sort');
		if (loaded) {
			let sd = persistedSort !== null ? JSON.parse(persistedSort) : sortDetails;
			let sortedDevices = sortDevices(
				[...peblGateways, ...vyneGateways, ...vyneNodes],
				sd[0],
				sd[1]
			);
			setDevices(sortedDevices);
			setThisLoading(false);

			if (selectedDevice) {
				setSelectedDevice(
					sortedDevices.find((d) => d.id === selectedDevice.id)
				);
			}
		}
	}, [peblGateways, vyneGateways, vyneNodes, loaded]);

	const applySort = () => {
		localStorage.setItem('device-sort', JSON.stringify(sortDetails));
		let sortedDevices = sortDevices(
			[...peblGateways, ...vyneGateways, ...vyneNodes],
			sortDetails[0],
			sortDetails[1]
		);
		setDevices(sortedDevices);
	};

	const breadcrumbs = [
		{ text: 'Devices', link: '/devices' },
		{ text: 'All', link: '' },
	];

	const actionButtons = () => {
		if (devices.length > 0) {
			return (
				<React.Fragment>
					<FingotiButton
						light
						color='primary'
						onClick={setAddOpen}
						disabled={!hasScope('device:write')}>
						Claim device
					</FingotiButton>
				</React.Fragment>
			);
		} else {
			return <></>;
		}
	};

	const handleCardClick = (device) => {
		setSelectedDevice(device);
	};

	const unsetSelectedDeivce = () => {
		setSelectedDevice({});
	};

	return thisLoading ? (
		<FingotiLoading />
	) : (
		<>
			<FingotiModal title='Claim Device' open={addOpen} setOpen={setAddOpen}>
				<ClaimGateway setOpen={setAddOpen} />
			</FingotiModal>
			<FingotiHeader
				breadcrumbs={breadcrumbs}
				sectionIcon={DeviceIcon}
				actionButtons={actionButtons()}
			/>
			<DevicesView
				deviceDetails={DeviceDetails(selectedDevice, classes)}
				deviceList={DeviceList(
					devices,
					handleCardClick,
					unsetSelectedDeivce,
					selectedDevice,
					applySort,
					setSortDetails
				)}
				openClaimModal={setAddOpen}
			/>
		</>
	);
};
